<template>
  <div class="px-4">
    <p class="overline mt-3 mb-0 pl-1 py-0">
      Participe ao vivo:
    </p>
    <!-- COMENTE AO VIVO -->
    <v-btn
      rounded
      color="btn-primary white--text"
      large
      class="my-4"
      @click.stop="golive = !golive"
      hover
      style="letter-spacing: 0"
      block
    >
      <v-icon
        class="mr-2"
        color="red"
      >
      mdi-record</v-icon>
      Entrar ao vivo
    </v-btn>
    <!-- GOLIVE DIALOG -->
    <v-dialog
      v-model="golive"
      max-width="350"
    >
      <v-card class="round-corner">
        <v-card-title class="headline">
          Aviso de redirecionamento
        </v-card-title>

        <v-card-text>
          Você será redirecionado para o WhatsApp, aonde receberá seu link e se juntará a nossa transmissão. Deseja prosseguir?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="red"
            text
            @click="(golive = false, registerEvent({ id: 'golive-evt', url: $router.currentRoute.path}))"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="btn-primary white--text"
            target="_blank"
            :href="link"
          >
            Prosseguir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapActions} from "vuex"

export default {
  name: 'GoLive',
  data() {
    return {
      golive: false,
      link: 'https://wa.me/+5521920088559?text=Quero%20participar%20do%20webinar%20e%20fazer%20minha%20pergunta%20online!',
    }
  },
  methods: {
    ...mapActions(['registerEvent', 'test']),
  }
}
</script>